module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.6cb8e311084d98a5a2cc60eb82488a8d.ttf";